import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as AdminIndexActions from '../../../actions/admin/Index/adminIndexAction';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import autoBind from 'auto-bind';
// import Switch from "react-switch";
import ReactTooltip from 'react-tooltip';

class feedbacksList extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			isLoader: true,
			feedbacksList: [],
			token: '',
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			totalCount: 0,
			verify: false,
			selectedTab :'SpecialistNA'
		}
		this.changeFeedbackType = this.changeFeedbackType.bind(this)
		this.handlePatientChange = this.handlePatientChange.bind(this)
    this.handleSpecialistChange = this.handleSpecialistChange.bind(this)
    this.handleApprovedChange = this.handleApprovedChange.bind(this);
	}

	componentWillMount() {
		let object = {
			page: this.state.activePage,
			count: this.state.count,
			verify: this.state.verify,
      isDoctorAddedFeedback:true,
      isSpecialistVerified: false,
      isPatientVerified: true,

		}
		this.props.actions.getFeedbacksList(object);
	}

	handlePageChange( tab, pageNumber) {

	const convertedDate = this.props.searchedDate;
    // debugger;
    if(tab == 'PatientNA'){
      var tabName = false
      var status = false
     var isSpecialistVerified= true
     var isPatientVerified= false
		}else if(tab == 'SpecialistNA'){
			var tabName = true
      var status  = false
      var isSpecialistVerified= false
      var isPatientVerified= true
		}
		else{
			var tabName = 'Approved'

		}
		this.setState({ activePage: pageNumber });
		let object = {
			page: pageNumber,
			count: this.state.count,
      		verify: this.state.verify,
			isSpecialistVerified: isSpecialistVerified,
			isPatientVerified: isPatientVerified,
			isDoctorAddedFeedback:tabName,
			date1: convertedDate != null ? convertedDate : null,
			date2: convertedDate != null ? convertedDate : null,
		}


		this.props.actions.getFeedbacksList(object);
	}

	handleSpecialistChange(status, id) {
		var obj = {
			tab: 'SpecialistNA',
      isSpecialistVerified: status,
      isPatientVerified: status,
			id: id,
			page: this.state.activePage,
			count: this.state.count,
      verify: this.state.verify,
      isDoctorAddedFeedback:true
		}
		this.props.actions.updateFeedbackStatus(obj);
	}

	handlePatientChange(status, id) {
    
		var obj = {
			tab:'PatientNA',
      		// isPatientVerified: false,
      		// isSpecialistVerified: true,
      		isPatientVerified: true,
      		isSpecialistVerified: false,
	  		id: id,
	  		page: this.state.activePage,
	  		count: this.state.count,
      		verify: this.state.verify,
      		isDoctorAddedFeedback:false
		}
		// console.log("shambhu was herer")
		// return 
		this.props.actions.updateFeedbackStatus(obj);
	}

	handleApprovedChange(status, id) {

			var tabName = 'Approved'


		var obj = {
    //   isPatientVerified: true,
    //   isSpecialistVerified: false,
      isPatientVerified: true,
      isSpecialistVerified: true,
			id: id,
			page: this.state.activePage,
			count: this.state.count,
      verify: this.state.verify,
      isDoctorAddedFeedback:tabName
		}
		this.props.actions.updateFeedbackStatus(obj);
	}
	changeFeedbackType(status , tab) {
		this.props.actions.changeSearchedDate(null)
		if(tab == 'PatientNA'){
      var tabName = false
      var isSpecialistVerified= true
      var isPatientVerified= false
		}else if(tab == 'SpecialistNA'){
			var tabName = true
      var isSpecialistVerified= false
      var isPatientVerified= true
		}
		else{
			var tabName = 'Approved'

		}
		this.setState({ verify: status,
						selectedTab :tab,
						activePage: 1
		})
		let object = {
			page: 1,
			count: this.state.count,
			verify: status,
      isDoctorAddedFeedback:tabName,
      isSpecialistVerified:isSpecialistVerified,
      isPatientVerified:isPatientVerified

		}
		console.log("tabname", tabName)
		this.props.actions.changeFeedbackType(tabName)
		this.props.actions.getFeedbacksList(object);
	}

	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	//function for sorting
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();
		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let object = {
			page: this.state.page,
			count: this.state.count,
			sorting: sorting
		}
		this.props.actions.getEmailTemplateList(object);
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.success) {
			this.setState({
				feedbacksList: nextProps.feedbacksList,
				totalCount: nextProps.totalCount,
				// isLoader: false
			})
		} else {
			this.setState({
				isLoader: false
			})
		}
	}

	render() {
		var feedbacksList = this.state.feedbacksList
		console.log("this.staet.handle", this.state.selectedTab)
		var rows = [];
		feedbacksList.forEach(function (item, index) {
			rows.push(
	<tr key={index}>
					{/* <td>{index + 1}</td> */}
					<td ><Moment format="DD-MMM-YYYY">{item.appointmentInfo.appointmentDate}</Moment></td>
					<td>{item.appointmentInfo.appointmentTime}</td>
					<td>{item.appointmentInfo.appointmentMode == 1 ? "F2F" : "Online"}</td>
					<td className = 'capitalize'>{item.patientInfo.userName}</td>
					<td className = 'capitalize'>{item.doctorInfo.userName}</td>

					{this.state.selectedTab == 'PatientNA'?
					<td >
						<a data-tip data-for={'patient' + index} className="Blogtext">
							{item.patientFeedback}
						</a>
						<ReactTooltip id={'patient' + index} aria-haspopup='true' type='warning' effect='solid' place='bottom' className="customeTheme" >
							<p>{item.patientFeedback}</p>
						</ReactTooltip>
					</td>
					 :null
				 	}
					{this.state.selectedTab == 'SpecialistNA' ?
					<td> 		<a data-tip data-for={'specialist' + index} className="Blogtext">{item.doctorFeedback}</a>
						<ReactTooltip id={'specialist' + index} aria-haspopup='true' type='warning' effect='solid' place='bottom' className="customeTheme" >
							<p>{item.doctorFeedback}</p>
						</ReactTooltip>
					</td>
					:null
					}
					<td>
					{this.state.selectedTab == 'SpecialistNA'  ?<img src={require('../../../images/check_blue.png')} onClick={this.handleSpecialistChange.bind(this, true, item._id)} style={{ 'cursor': 'pointer' }} />:null}
					{this.state.selectedTab == 'PatientNA'  ?<img src={require('../../../images/check_blue.png')} onClick={this.handlePatientChange.bind(this, true, item._id)} style={{ 'cursor': 'pointer' }} />:null}
					{this.state.selectedTab == 'Approved' ?<img src={require('../../../images/reject.png')} onClick={this.handleApprovedChange.bind(this, false, item._id)} style={{ 'cursor': 'pointer' }} />:null}

					</td>
					{/* <td>
						<img src={require('../../../images/check_blue.png')} onClick={this.handleSpecialistChange.bind(this, true, item._id)} style={{ 'cursor': 'pointer' }} />
						<img src={require('../../../images/reject.png')} onClick={this.handleSpecialistChange.bind(this, false, item._id)} style={{ 'cursor': 'pointer' }} />
						}
					</td> */}
				</tr >
			)
		}.bind(this));
		return (
			<div className="content-wrapper" >

				<section className="content container-fluid">
					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link href="#tab_1" data-toggle="tab" className="active show" onClick={this.changeFeedbackType.bind(this, false,'SpecialistNA')} > Non Approved Specialist Feedbacks</Link></li>
										<li ><Link href="#tab_2" data-toggle="tab"  onClick={this.changeFeedbackType.bind(this, false,'PatientNA')} > Non Approved Patient Feedbacks</Link></li>
										<li ><Link href="#tab_3" data-toggle="tab"  onClick={this.changeFeedbackType.bind(this, true,'Approved')} > Approved Feedbacks</Link></li>

									</ul>
									<div className="uploadImg-btn">
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="tab-content tabother ">
												<div className="row">
													<div className="box-body table-responsive no-padding aTable">
														<div className="table-responsive">
															<table className="table">
																<tbody>
																	<tr>
																		{/* <th >Sr. No.</th> */}
																		<th>Appointment Date</th>
																		<th>Appointment Time</th>
																		<th>Appointment Mode</th>
																		<th>Specialist Name</th>
																		<th>Patient Name</th>
																{ this.state.selectedTab == 'PatientNA'	?	<th>Patient Feedback</th> :null }
																{this.state.selectedTab == 'SpecialistNA'	?		<th>Specialist Feedback</th>:null}
																{ this.state.selectedTab == 'PatientNA'	  || this.state.selectedTab == 'SpecialistNA' ? <th >Approve Feedback</th>
																:<th >Revoke Feedback</th>}
																		{/* <th >Approve Specialists Feedback</th> */}
																	</tr>
																	{rows && rows.length > 0 ? rows : <tr><td colSpan={4} className="text-center">There are no Feedback(s) yet.</td></tr>}
																</tbody>
															</table>
														</div></div>
												</div>
												{(this.state.totalCount && this.state.totalCount > 10) ?
													<div className="row">
														<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
														<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
															<Pagination
																prevPageText='Prev'
																nextPageText='Next'
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCount}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this,this.state.selectedTab)}
															/>
														</div>
													</div> : ''}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		feedbacksList: state.adminUser.feedbacks ? state.adminUser.feedbacks.data : [],
		totalCount: state.adminUser.feedbacks ? state.adminUser.feedbacks.totalCount : 0,
		success: state.adminUser.feedbacks ? state.adminUser.feedbacks.success : false,
		searchedDate: state.adminUser.changeSearchedDate ? state.adminUser.changeSearchedDate : null
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(AdminIndexActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(feedbacksList);
